<template>
	<v-layout row wrap>
		<div class="flex xl12 lg12 md12 mx-auto">
			<v-card style="width: 100%" color="transparent" elevation="0">
				<v-card-title class="px-1 pt-0">
					<v-flex x12> <h1 class="hidden-sm-and-down">Units</h1> </v-flex>
					<v-spacer></v-spacer>
					<v-tabs v-model="dataType" fixed-tabs color="transparent">
						<v-tab
							v-for="(tab, index) in tabs"
							:key="tab"
							:href="'#' + tab"
							ripple
							>{{ text[index] }}</v-tab
						>
						<v-tabs-slider color="blue"></v-tabs-slider>
					</v-tabs>
					<v-spacer></v-spacer>
					<v-text-field
						prepend-inner-icon="search"
						label="Zoeken"
						single-line
						hide-details
						v-model="search"
					></v-text-field>
				</v-card-title>

				<v-data-table
					v-model="selected"
					v-bind:headers="headers[dataType]"
					v-bind:items="items"
					v-bind:search="search"
					v-bind:pagination.sync="pagination"
					:rows-per-page-items="[25, 50]"
					:loading="!showTable"
					no-data-text=""
					item-key="id"
				>
					<v-progress-linear
						slot="progress"
						color="blue"
						indeterminate
					></v-progress-linear>
					<template slot="headers" slot-scope="props">
						<tr class="hidden-sm-and-down">
							<th
								v-for="header in props.headers"
								:key="header.text"
								:class="[
									'column sortable text-xs-left',
									pagination.descending ? 'desc' : 'asc',
									header.value === pagination.sortBy ? 'active' : ''
								]"
								@click="changeSort(header.value)"
								ß
							>
								<v-icon>arrow_upward</v-icon>
								{{ header.text }}
							</th>
						</tr>
					</template>
					<template slot="items" slot-scope="props">
						<tr
							v-if="dataType == 'getUnits'"
							:active="props.selected"
							@click="showUnit(props.item)"
						>
							<td class="hidden-xs-only">{{ props.item.unitId }}</td>
							<td class="hidden-xs-only">
								<img
									v-if="!failedImages[props.item.unitId]"
									v-bind:src="utils.getUnitImage(props.item.unitId)"
									style="max-width: 48px"
									@error="setPlaceholder(props.item.unitId)"
								/>
								<v-icon 
									v-else
									style="font-size: 48px"
								>directions_car</v-icon>
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showUnit(props.item)"
							>
								{{ props.item.name }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.license }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.color }}
							</td>
							<td class="text-xs-left hidden-xs-only">{{ props.item.fuel }}</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.priceCat }}
							</td>
							<td class="text-xs-right hidden-xs-only">
								{{ props.item.totalRentSum }}
							</td>
							<td class="text-xs-right hidden-xs-only">
								<v-icon
									class="right"
									style="transform: translate(50%,0)"
									color="green"
									v-if="props.item.active == '1'"
									>checked</v-icon
								>
							</td>
							<td class="text-xs-left hidden-sm-and-up itemRow">
								<b
									>{{ props.item.name }} {{ props.item.unitId }}
									{{ props.item.license }}</b
								><br />
								{{ props.item.color }} {{ props.item.fuel }} <br />Prijs
								categorie: {{ props.item.priceCat }} <br />{{
									props.item.totalRentSum
								}}
								<br />
								Pincode: {{ props.item.fuelCardPin }}
								<!--<device-battery class="right" style="transform: translate(100%,-5px);"></device-battery>-->
								<v-icon
									class="right"
									style="transform: translate(50%,0)"
									color="green"
									v-if="props.item.active == '1'"
									>checked</v-icon
								>
							</td>
						</tr>
						<tr
							v-if="dataType == 'getWialonUnits' && showTable"
							:active="props.selected"
							@click="showUnit(props.item)"
						>
							<td class="text-xs-left" @click="showUnit(props.item)">
								{{ props.item.i }}
							</td>
							<td class="text-xs-left">{{ props.item.d.nm }}</td>
						</tr>
					</template>
				</v-data-table>
			</v-card>
		</div>
	</v-layout>
</template>
<script>
import * as utils from '@/utils/utils';
import { _ } from 'vue-underscore';
export default {
	name: 'UnitsTable',
	data() {
		return {
			dialog: false,
			showTable: false,
			utils: utils,
			pagination: {
				sortBy: 'name'
			},
			selected: [],
			search: '',
			cacheItems: {},
			items: [],
			tabs: ['getUnits', 'getWialonUnits'],
			text: ['In gebruik', 'Beschikbaar'],
			dataType: 'getUnits',
			failedImages: {},
			headers: {
				getUnits: [
					{ text: '#', align: 'left', value: 'id' },
					{ text: '', value: 'image' },
					{ text: 'Naam', value: 'name' },
					{ text: 'Kenteken', value: 'license' },
					{ text: 'Kleur', value: 'color' },
					{ text: 'Brandstof', value: 'fuel' },
					{ text: 'Pricecat', value: 'priceCat' },
					{ text: 'Totaal', value: 'totalRentSum' },
					{ text: 'Actief', value: 'active' }
				],
				getWialonUnits: [
					{ text: 'DeviceId', value: 'wialonUnitId' },
					{ text: 'Omschrijving', value: 'Description' }
				]
			}
		};
	},
	props: ['dataTimeStamp'],
	created: function() {
		this.getData();
	},
	watch: {
		dataType() {
			this.getData();
		},
		dataTimeStamp() {
			this.getData();
		}
	},
	methods: {
		getData() {
			var self = this;
			this.showTable = false;
			var extraParameters = self.dataType === 'getUnits' ? '0' : '';
			utils
				.getData(
					basePath + 'api/rentunits/' + self.dataType + '/' + extraParameters
				)
				.then(function(json) {
					self.showTable = true;
					switch (self.dataType) {
						case 'getUnits':
							self.items = json.data;
							break;

						case 'getWialonUnits':
							let usedUnits = _.pluck(json.usedUnits, 'wialonUnitId');
							self.items = _.reject(json.wialonUnits, function(unit) {
								return usedUnits.indexOf(String(unit.i)) > -1;
							});
							break;
					}
				});
		},
		showUnit(unit) {
			var selectedUnit = {};
			if (unit.i) {
				selectedUnit = {
					name: '',
					wialonUnitId: String(unit.d.id),
					sensors: unit.d.sens,
					license: '',
					new: true
				};
			} else {
				selectedUnit = unit;
			}
			selectedUnit.edit = true;
			this.$emit('showUnit', selectedUnit);
		},
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		setPlaceholder(unitId) {
			this.$set(this.failedImages, unitId, true);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Units/UnitsTable.vue